var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cv-builder"},[_c('change-data',{attrs:{"data":_vm.data,"updateData":_vm.updateData}}),_c('my-cv',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }